<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <div v-if="invoices.length < 1">
        {{ $t('invoices.noInvoicesYet') }}
      </div>
      <va-list v-if="invoices.length > 0" fit class="mb-2">
        <va-list-label>
          {{ $t('invoices.invoices') }}
        </va-list-label>
        <div v-for="(invoice, index) in invoices" v-bind:key="invoice.invoiceId">
          <va-item :key="'item' + invoice.invoiceId" clickable>
            <va-item-section>
              <va-item-label>
                {{ invoice.subscription.name }}
              </va-item-label>

              <va-item-label caption>
                {{ invoice.createdDatetime | moment("MMMM Do YYYY") }}
              </va-item-label>

            </va-item-section>
            <va-item-section side>
              {{ invoice.payment.amount }} €
            </va-item-section>
            <va-item-section side>
              <va-badge :color="getStatusColor(invoice.isPayed)">
                {{ invoice.isPayed ? $t('invoices.paid') : $t('invoices.unpaid') }}
              </va-badge>
            </va-item-section>
            <va-item-section side>
              <va-button-group>
                <va-button flat small color="gray" :disabled="invoiceDownload"
                  @click="downloadInvoice(invoice.invoiceId)" icon="fa fa-cloud-download"></va-button>
                <va-button flat small color="gray" v-if="!invoice.isPayed"
                  @click="toInvoice(invoice.invoiceId)"
                  icon-right="fa fa-credit-card"></va-button>
              </va-button-group>
            </va-item-section>
          </va-item>

          <va-list-separator v-if="index < invoices.length - 1" :key="'separator' + invoice.invoiceId" />
        </div>
      </va-list>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  name: 'Invoices',
  data () {
    return {
      invoices: [],
      invoiceDownload: false,
    }
  },
  methods: {
    async toInvoice (invoiceId) {
      await this.$router.push({
        name: 'invoice',
        params: { invoiceId: invoiceId },
      })
    },
    getStatusColor (status) {
      if (status) {
        return 'success'
      }
      return 'danger'
    },
    forceFileDownload (response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title) // or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downloadWithVueResource (resp) {
      this.$http({
        method: 'get',
        url: resp.invoiceUrl,
        responseType: 'arraybuffer',
      })
        .then(response => {
          this.forceFileDownload(response, resp.invoiceName)
        })
        .catch((err) => this.errorHandler(err.response))
    },
    downloadInvoice (invoiceId) {
      this.invoiceDownload = true
      this.$store.dispatch('getPdfInvoice', invoiceId).then((resp) => {
        this.downloadWithVueResource(resp.data.message)
        // eslint-disable-next-line no-return-assign
      }).then(() => this.invoiceDownload = false)
        .catch((err) => this.errorHandler(err.response))
    },
    async initInvoices () {
      this.invoices.splice(0, this.invoices.length, ...this.$store.getters.invoices)
      this.$store.commit('setLoading', false)
    },
  },
  computed: {},
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getInvoices')
      .then(() => this.initInvoices())
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style lang="scss">
  .markup-tables {
    .va-table {
      width: 100%;
    }

    .va-card {
      max-width: 1200px;
    }
  }
</style>
